import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import BaseUrl from "../Components/BaseUrl";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const Student = () => {
  const years = Array.from(
    { length: new Date().getFullYear() - 1950 + 1 },
    (_, i) => 1950 + i
  ).reverse();
  const [checked, setChecked] = React.useState(true);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    school: "",
    startyear:"",
    endyear:"",
    bdate:"",
    bmonth:"",
    byear:""
  });
  const [error, setError] = useState({
    school: "",
    startyear:"",
    endyear:"",
    bdate:"",
    bmonth:"",
    byear:""
  });

  const handlecheckChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setError({ ...error, [id]: "" });
  };
  const validateForm = () => {
    let isValid = true;
    let errors = {};
    if (formData.school.trim() === "") {
      errors.school = "School or College is required";
      isValid = false;
    }
    if (formData.startyear === "") {
      errors.startyear = "Start year is required";
      isValid = false;
    }
    if (formData.endyear === "") {
      errors.endyear = "End year is required";
      isValid = false;
    }
    if (formData.byear === "") {
      errors.byear = "Year is required";
      isValid = false;
    }
    if (formData.bdate   === "") {
      errors.bdate = "Date is required";
      isValid = false;
    }
    if (formData.bmonth === "") {
      errors.bmonth = "Month is required";
      isValid = false;
    }
    setError(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = validateForm();
    if (result) {
      try {
        const response = await axios.post(
          BaseUrl + "onboarding/step3",
          formData,
          {
            headers: {
              "user-id": user_id,
            },
          }
        );
        console.log(response.data.status);
        if (response.status === 200) {
          setFormData({
            title: "",
            employment_type: "",
            comapany: "",
          });
          setTimeout(() => {
            navigate("/user/onboarding/step4");
          }, 100);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-start min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
        <div className="w-2/4 mb-4 mt-6 ">
          <p className="text-3xl  mb-2 text-center">
            {" "}
            Your profile helps you discover new people and opportunities
          </p>
        </div>
        <div className="w-full max-w-md">
          <form className="bg-white p-8 rounded-lg shadow-xl ">
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                School or College/University{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="school"
                value={formData.school}
                onChange={handleChange}
                type="text"
              />
              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.school}
              </span>
            </div>

            <div className="mb-6">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label
                    className="block text-gray-700 text-sm font-semibold mb-1"
                    htmlFor="name"
                  >
                    Start Year <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="startyear"
                    value={formData.startyear}
                    onChange={handleChange}
                    className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 
                  text-gray-700 leading-tight focus:outline focus:shadow-outline "
                  >
                    <option value="">-</option>
                    {years?.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  <span className="text-red-500 ml-1 text-sm mb-1">
                    {error.startyear}
                  </span>
                </div>
                <div>
                  <label
                    className="block text-gray-700 text-sm font-semibold mb-1"
                    htmlFor="name"
                  >
                    End Year(or expected)
                    <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="endyear"
                    value={formData.endyear}
                    onChange={handleChange}
                    className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 
                  text-gray-700 leading-tight focus:outline focus:shadow-outline"
                  >
                    <option value="">-</option>
                    {years?.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  <span className="text-red-500 ml-1 text-sm mb-1">
                    {error.endyear}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex  items-center shadow appearance-none border rounded-md">
              <div className="w-3/4 ">
                <p className="text-[14px] text-gray-400 font-medium ml-4">
                  I'm over 16
                </p>
              </div>
              <div className="w-1/4  flex items-center justify-center ">
                <Switch
                  checked={checked}
                  onChange={handlecheckChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
            </div>

            {!checked && (
              <div className="mt-4">
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <label
                      className="block text-gray-700 text-sm font-semibold mb-1"
                      htmlFor="start_year"
                    >
                      Year <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="start_year"
                      // value={educationformData.start_year}
                      // onChange={oneducationformDataChange}
                      className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 
                    text-gray-700 leading-tight focus:outline focus:shadow-outline "
                    >
                      <option value="">-</option>
                      {years?.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                    <span className="text-red-500 ml-1 text-sm mb-1">
                      {error.byear}
                    </span>
                  </div>

                  <div>
                    <label
                      className="block text-gray-700 text-sm font-semibold mb-1"
                      htmlFor="start_month"
                    >
                      Month <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="start_month"
                      // value={educationformData.start_month}
                      // onChange={oneducationformDataChange}
                      className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 
                    text-gray-700 leading-tight focus:outline focus:shadow-outline "
                    >
                      <option value="">-</option>
                      {[
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                      ].map((month, index) => (
                        <option key={index} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                    <span className="text-red-500 ml-1 text-sm mb-1">
                      {error.bmonth}
                    </span>
                  </div>

                  <div>
                    <label
                      className="block text-gray-700 text-sm font-semibold mb-1"
                      htmlFor="start_date"
                    >
                      Date <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="start_date"
                      // value={educationformData.start_date}
                      // onChange={oneducationformDataChange}
                      className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 
                    text-gray-700 leading-tight focus:outline focus:shadow-outline "
                    >
                      <option value="">-</option>
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(
                        (date) => (
                          <option key={date} value={date}>
                            {date}
                          </option>
                        )
                      )}
                    </select>
                    <span className="text-red-500 ml-1 text-sm mb-1">
                      {error.bdate}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className=" mt-2 flex flex-col items-center justify-center w-full">
              <Link
                to={"/user/onboarding/step3"}
                className=" hover:text-black text-center text-gray-600 text-lg font-bold py-2 px-4 h-12 rounded-full w-full "
              >
                I'm not a student
              </Link>
            </div>

            <div className=" mt-2 flex flex-col items-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white text-lg font-bold py-2 px-4 h-12 rounded-full w-full"
                type="button"
                onClick={handleSubmit}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Student;
